import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import Tasks from './Tasks';
import { ENABLE_MODAL_SWIPE_BACK } from '../utils/mobileModalSwipe';

export default function TasksMobile({ open, onClose, initialFileForCreate, onConsumedInitialFile }) {
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!ENABLE_MODAL_SWIPE_BACK) {
      touchStartX.current = null;
      touchEndX.current = null;
      return;
    }
    if (!touchStartX.current || !touchEndX.current) return;

    if (touchStartX.current - touchEndX.current > 50) {
      onClose();
    }

    touchStartX.current = null;
    touchEndX.current = null;
  };

  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 100002, // Выше SidebarNav (100001)
        display: 'flex',
      }}
      {...(ENABLE_MODAL_SWIPE_BACK ? { onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd } : {})}
    >
      <Tasks
        modal
        isMobile
        onClose={onClose}
        initialFileForCreate={initialFileForCreate}
        onConsumedInitialFile={onConsumedInitialFile}
      />
    </div>,
    document.body
  );
}
